import DialogWrap from './DialogWrap';
import Panel from './Dialog/Content/Panel';
import type { IDialogPropTypes as DialogProps } from './IDialogPropTypes';

export type { DialogProps };
export { Panel };

export default DialogWrap;
